import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { buildWhatsappUrl, CONTACT_PHONE_TEL } from '~/config/contact'

type LeadErrorNoticeProps = {
  /** `<feature>.error.<subtype>` — takes {phone} and {whatsapp} placeholders. */
  messageId: string
  /** `<feature>.whatsapp.prefill` — text pre-filled into the WhatsApp draft. */
  prefillId: string
  prefillValues?: Record<string, string | number>
  /** The host form's own error class — every form module styles it itself. */
  className?: string
  testId: string
}

/**
 * A failed submit must leave the visitor a channel that works right now, not
 * just an apology: the shop phone as a tap-to-call link and a WhatsApp draft
 * carrying the context of the form they were filling in.
 */
export const LeadErrorNotice: React.FC<LeadErrorNoticeProps> = ({
  messageId,
  prefillId,
  prefillValues,
  className,
  testId,
}) => {
  const intl = useIntl()

  return (
    <p className={className} data-testid={testId}>
      <FormattedMessage
        id={messageId}
        values={{
          phone: (
            <a href={`tel:${CONTACT_PHONE_TEL}`}>
              <FormattedMessage id="contacts.ourPhone" />
            </a>
          ),
          whatsapp: (
            <a
              href={buildWhatsappUrl(
                intl.formatMessage({ id: prefillId }, prefillValues)
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </a>
          ),
        }}
      />
    </p>
  )
}
